import React from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, Star } from "lucide-react";
import { CAT_ICON, catColor, fmt, startPrice, imgUrl } from "@/lib/catalog";

export default function ProductCard({ p, list = false }) {
  const nav = useNavigate();
  const Icon = CAT_ICON[p.cat] || CAT_ICON.food;
  const src = imgUrl(p.image);

  const thumb = (
    <div
      className="flex items-center justify-center text-white relative shrink-0 overflow-hidden"
      style={{
        background: `linear-gradient(140deg, ${catColor(p.cat)}, ${catColor(p.cat)}cc)`,
        height: list ? "auto" : 100,
        width: list ? 96 : "auto",
        alignSelf: "stretch",
      }}
    >
      {src ? (
        <img src={src} alt={p.name} loading="lazy" className="w-full h-full object-cover" style={{ minHeight: list ? 96 : 100 }} />
      ) : (
        <Icon size={list ? 26 : 30} strokeWidth={1.7} />
      )}
    </div>
  );

  const body = (
    <div className="p-3 flex-1 flex flex-col justify-center text-right">
      <p className="font-head text-[13.5px] font-bold leading-tight mb-1 line-clamp-2" style={{ color: "var(--k-ink)" }}>
        {p.name}
      </p>
      <p className="text-[11px] mb-2 flex items-center gap-1 justify-end" style={{ color: "var(--k-ink-soft)" }}>
        <BadgeCheck size={12} style={{ color: "var(--k-emerald)" }} />
        {p.store} · {p.city}
      </p>
      <div className="flex items-baseline justify-between">
        <span className="font-num font-bold text-[14px]" style={{ color: "var(--k-ink)" }}>
          {fmt(startPrice(p))} <span className="font-ui font-normal text-[10px]" style={{ color: "var(--k-ink-soft)" }}>د.ل / من</span>
        </span>
        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ color: "var(--k-gold-deep)", background: "var(--k-gold-tint)" }}>
          الحد {p.moq}
        </span>
      </div>
      {p.rating != null && (
        <span className="mt-1.5 flex items-center gap-0.5 text-[10px] justify-end" style={{ color: "var(--k-ink-soft)" }}>
          <Star size={10} fill="var(--k-gold)" strokeWidth={0} /> {p.rating}
        </span>
      )}
    </div>
  );

  return (
    <button
      data-testid={`product-card-${p.id}`}
      onClick={() => nav(`/product/${p.id}`)}
      className="k-tap k-rise overflow-hidden rounded-2xl text-right"
      style={{
        background: "var(--k-surface)",
        border: "1px solid var(--k-line)",
        display: "flex",
        flexDirection: list ? "row-reverse" : "column",
        boxShadow: "0 1px 2px rgba(18,32,58,.05)",
      }}
    >
      {thumb}
      {body}
    </button>
  );
}
